import React from 'react';
import localized, { messages } from '../../core/i18n';
import $ from 'jquery';


const TermsAndConditions = () => {
	const showPPModal = () => $('#privacy-policy-modal').modal('show');
	return <div className="terms-and-policy">
		<div className="mb-10">
			<div className="title">This Agreement</div>
			<div>
				This agreement (“Agreement”) is a binding legal contract between you and Channel Factory LLC
				(and any predecessor and successor entities) (“Channel Factory”),
				covering your use of the website www.channelfactory.com and other Channel Factory websites
				(“Sites”) and any of our services,
				including without limitation our video research and media buying software platform (“Services”).
				If you do not agree to all of the terms in this Agreement, please do not use the Sites or the
				Services – if you visit the Sites or use any Services,
				you are necessarily agreeing to this Agreement.
			</div>
		</div>
		<div className="mb-10">
			<div className="title">Authorization</div>
			You may access and use the Sites and/or Services only if you are 18 years or older and capable of
			forming a binding contract with Channel Factory
			and are not barred from accessing and using the Sites and/or Services under applicable law.
			If you are accessing and using the Sites or Services on behalf of a company (such as your employer)
			or other legal entity,
			you represent and warrant that you have the authority to bind that company or other legal entity to
			this Agreement. In that case,
			“you” and “your” will refer to that company or other legal entity.
		</div>
		<div className="mb-10">
			<div className="title">Your Account</div>
			<ol className="main">
				<li>Some portions of the Sites and some Services can only be accessed with an account
					(“Account”).
				</li>
				<li>
					You are responsible for everything done through your Account so please do not share your ID
					and password with anyone you do not want to be accountable for.
					Please notify us immediately at <a
					href="mailto:contact@viewiq.com">contact@viewiq.com</a> if you have lost control
					of your Account ID or password or you suspect there is unauthorized activity in your Account.
				</li>
				<li>Within your Account, you can Authenticate your YouTube channel or YouTube channels (or your
					YouTube CMS).
				</li>
			</ol>
		</div>
		<div className="mb-10">
			<div className="title">Information Collection</div>
			<div className="mb-5">
				We generally use this information to provide and improve our Services, to generate statistics on
				how the Services are used,
				to administer your use of the Services (including your Account, if you are an Account holder),
				for media buying purposes, and to enable you to enjoy and easily navigate our Services.
			</div>
			Information collected from Channel Factory Services:
			<ol className="disc">
				<li>
					<b>Automatic Collection:</b> Like most web businesses, we use automated mechanisms (e.g.,
					Cookies and/or Web Beacons)
					to keep track of user interactions with our Services. “Cookies” are small text files that
					are placed on your device by a Web server when you access our Services.
					We may use both session Cookies and persistent Cookies to identify that you’ve logged in to
					the Services and to tell us how and when you interact with our Services.
					We may also use Cookies to monitor aggregate usage and web traffic routing on our Services
					and to customize and improve our Services. Unlike persistent Cookies,
					session Cookies are deleted when you log off from the Services and close your browser.
					Although most browsers automatically accept Cookies,
					you can change your browser options to stop automatically accepting Cookies or to prompt you
					before accepting Cookies.
					Please note, however, that if you don’t accept Cookies, you may not be able to access all
					portions or features of the Services.
					Some third-party services providers that we engage (including third-party advertisers) may
					also place their own Cookies on your device.
					Note that this <u>Privacy Policy</u> covers only our use of Cookies and does not include use
					of Cookies by such third parties.
					“Web Beacons” (also known as Web bugs, pixel tags or clear GIFs) are tiny graphics with a
					unique identifier that may be included on our Services for several purposes,
					including to deliver or communicate with Cookies, to track and measure the performance of
					our Services, to monitor how many visitors view our Services,
					and to monitor the effectiveness of our advertising. Unlike Cookies, which are stored on the
					user’s device,
					Web Beacons are typically embedded invisibly on web pages (or in an e-mail).
					Our servers also automatically record certain information about how a person uses our
					Services (we refer to this information as “Log Data”),
					including both Account holders and non-Account holders (either, a “User”).
					Log Data may include information such as a User’s Internet Protocol (IP) address, browser
					type, operating system,
					the web page that a User was visiting before accessing our Services, the pages or features
					of our Services to which a User browsed and the time spent on those pages or
					features, search terms, the links on our Services that a User clicked on and other
					statistics.
					We use Log Data to administer the Services and we analyse (and may engage third parties to
					analyse) Log Data to improve,
					customize and enhance our Services by expanding their features and functionality and
					tailoring them to our Users’ needs and preferences.
					We may use a person’s IP address to generate aggregate, non-identifying information about
					how our Services are used.
					We also use third party services such as Mixpanel and Google Analytics to gather and analyse
					user information.
				</li>
				<li>
					<b>Volunteered:</b> If you open an Account with us, purchase products or services, send us
					an email, or share personal information with us in any other way,
					we collect this information. This obviously depends on what information you choose to
					provide but it may include your name, email address or billing information.
					You do not have to share this information with us, but without it you may not be able to
					access certain content, features or Services.
				</li>
				<li>
					<b>Authentication of Data from SNS Platforms:</b> Via the Settings section of your Account,
					you may choose to opt-in and allow Channel Factory to connect to one (1) or more of your SNS
					Accounts (e.g. YouTube Channel or YouTube Channel with CMS)
					so that Channel Factory may access data from the applicable SNS platforms on your behalf and
					/ or channels that are part of your YouTube CMS (such data collectively,
					the “Authenticated Data”). The Authenticated Data will include your YouTube’s Channel (or
					your partnering YouTube Channels linked to your YouTube’s CMS)
					publicly available data (e.g., channel’s number of subscribers, video views, number of
					comments, etc) as well as data available only via YouTube’s
					Analytics and Reporting API (e.g., Video Traffic Sources, Demographic Data and Video
					Transcripts). Channel Factory may use Authenticated Data to improve the Services
					for you (e.g. by using such data to deliver analytics insights, rankings regarding your
					YouTube Channel, and analyzing your YouTube Channel gains the Advertisers’
					brand safety criteria) and to improve the Services overall. Your authenticated data will be
					available only to Channel Factory and its Media Partners.
				</li>
			</ol>
		</div>
		<div className="mb-10">
			<div className="title">Things You Cannot Do</div>
			<ol className="main">
				<li>Lie to us in connection with your use of the Sites or the Services. This includes but is not
					limited to giving false information in your Account registration.
				</li>
				<li>Open a new Account without our written permission if we have terminated a prior Account or
					suspended your access to the Sites or any Services.
				</li>
				<li>Transfer your Account to someone else.</li>
				<li>
					Do anything that smacks of bad online citizenship such as spam our users, distribute spyware
					or viruses, collect personal information without disclosing and abiding by
					your privacy policy, or attempt to reverse engineer or hack into our systems.
				</li>
				<li>
					Bypass any technical protections or throttling that we institute, or access, use or scrape
					the Sites or the Services by any automated means unless you are a
					search engine crawling the Sites for the sole purpose of creating a publicly accessible
					search index.
				</li>
				<li>Do anything we ask you not to.</li>
			</ol>
		</div>
		<div className="mb-10">
			<div className="title">Infringement</div>
			<div>
				Channel Factory is strongly committed to respecting intellectual property and other rights. To
				report infringement, please email us right away at
				<a href="mailto:contact@viewiq.com">contact@viewiq.com</a>.
			</div>
		</div>
		<div className="mb-10">
			<div className="title">Ownership; Licenses</div>
			<div>
				<u>Content and Content Rights</u> For purposes of this Agreement: (i) <b>“Content”</b> means
				text, graphics, images, music, channels, audio, video,
				works of authorship of any kind, and information or other materials that are posted, generated,
				provided or otherwise made available through the Sites or Services;
				and (ii) <b>“User Content”</b> means any Content that users (including you) provide to be made
				available through the Sites or Services.
				Content includes without limitation User Content. <u>Content Ownership and
				Responsibility</u> Channel Factory does not claim any ownership rights in any User Content
				and nothing in this Agreement will be deemed to restrict any rights that you may have to use and
				exploit your User Content. Subject to the foregoing,
				Channel Factory and its licensors exclusively own all right, title and interest in and to the
				Sites and Services and Content, and all underlying software,
				technology and processes and any enhancements or modifications thereto, including all associated
				intellectual property rights therein. You acknowledge that the Sites,
				Services and Content are protected by copyright, trademark, and other laws of the United States
				and foreign countries. You agree not to remove,
				alter or obscure any copyright, trademark, service mark or other proprietary rights notices
				incorporated in or accompanying the Sites, Services or Content.
				<u>Rights in User Content Granted by You</u> By making any User Content available through the
				Sites or Services you hereby grant to Channel Factory a non-exclusive,
				transferable, sublicenseable, worldwide, royalty-free license to use, copy, modify, create
				derivative works based upon, publicly display, publicly perform and distribute
				your User Content in connection with operating and providing the Services and Content. You are
				solely responsible for all your User Content. You represent and warrant
				that you own all your User Content or you have all rights that are necessary to grant us the
				license rights in your User Content under this Agreement.
				You also represent and warrant that neither your User Content, nor your use and provision of
				your User Content to be made available through the Sites or Services,
				nor any use of your User Content by Channel Factory on or through the Services will infringe,
				misappropriate or violate a third party’s intellectual property
				rights, or rights of publicity or privacy, or result in the violation of any applicable law or
				regulation. <u>Rights in Content Granted by Channel Factory</u>
				Subject to your compliance with this Agreement, Channel Factory grants you a limited,
				non-exclusive, non-transferable, non-sublicensable license to view, copy,
				display and print the Content solely in connection with your permitted use of the Sites and
				Services. <u>Content from Authenticated SNS Accounts</u>
				If you have an Account, you may choose to link your Account with third-party social networking
				services (such as Facebook, Google, or YouTube)
				(each, a social networking service or “SNS”) with which you have an account (each such account,
				a “Third Party Account”) by either: (i) providing your Third Party
				Account login information to Channel Factory through the Sites or Services; or (ii) allowing
				Channel Factory to access your Third Party Account, as
				is permitted under the applicable terms and conditions that govern your use of each Third Party
				Account in the manner described above.
				You represent that you are entitled to disclose your Third Party Account login information to
				Channel Factory and/or grant Channel Factory access to
				your Third Party Account (including, but not limited to, for use for the purposes described
				herein), without breach by you of any of the terms and
				conditions that govern your use of the applicable Third Party Account and without obligating
				Channel Factory to pay any fees or making Channel Factory
				subject to any usage limitations imposed by such third party service providers. By granting
				Channel Factory access to any Third Party Accounts,
				you understand that Channel Factory may access, make available and store (if applicable) any
				Content that you have provided to and stored in your Third
				Party Account (“Third Party Account Content”) so that it is available through the Sites and/or
				Services (as further described in our <a href="#" onClick={() => showPPModal()}>
				{localized(messages.REGISTRATION_PAGE.PRIVACY_POLICY)}</a>). Unless otherwise specified in this
				Agreement, all Third Party Account Content, if any, will be considered to be User Content
				for all purposes of this Agreement. Please note that if a Third Party Account or associated service becomes
				unavailable or Channel Factory’ access to such Third Party Account is terminated by the third
				party service provider, then the Third Party Account Content that
				was available from such Third Party Account will no longer be available through the Sites or
				Services. You have the ability to disable the connection between
				your Account and your Third Party Accounts, at any time, through the Sites and/or Services.
				PLEASE NOTE THAT YOUR RELATIONSHIP WITH THE THIRD PARTY SERVICE PROVIDERS ASSOCIATED WITH YOUR
				THIRD PARTY ACCOUNTS IS GOVERNED SOLELY BY YOUR AGREEMENT(S)
				WITH SUCH THIRD PARTY SERVICE PROVIDERS. Channel Factory makes no effort to review any Third
				Party Account Content for any purpose, including without
				limitation for accuracy, legality or non-infringement and Channel Factory is not responsible for
				any Third Party Account Content.
			</div>
		</div>
		<div className="mb-10">
			<div className="title">Feedback</div>
			<div>
				We welcome feedback, comments and suggestions for improvements to the Sites and/or
				Services <b>(“Feedback”)</b>. You can submit Feedback by emailing us at <a href="mailto:contact@viewiq.com">
				contact@viewiq.com</a>. You grant to us a non-exclusive, worldwide, perpetual, irrevocable, fully-paid,
				royalty-free, sublicensable and transferable license under any and all intellectual property
				rights that you own or control to use, copy, modify,
				create derivative works based upon and otherwise exploit the Feedback for any purpose.
			</div>
		</div>
		<div className="mb-10">
			<div className="title">Privacy</div>
			<div>
				Channel Factory’ Privacy Policy is located <a href="#" onClick={() => showPPModal()}>
				{localized(messages.REGISTRATION_PAGE.PRIVACY_POLICY)}</a>.
				You will not use the Services to collect any personally identifiable information and you will
				not associate any data gathered through any Service from your website(s)
				with any personally identifying information from any source. You will post and abide by a
				privacy policy that meets or exceeds good industry practices and you
				will comply with all applicable laws covering collection of user information. If you use our
				analytics Services, your privacy policy must disclose that you use a
				third party service that collects anonymous information about users and user behavior on your
				website(s) and/or related to your advertising.
			</div>
		</div>
		<div className="mb-10">
			<div className="title">Indemnity, Disclaimers and Limits on Liability</div>
			<ol className="main">
				<li>
					You will indemnify, defend, and hold harmless Channel Factory, its affiliates, officers,
					directors, shareholders, employees, contractors, licensors, licensees,
					agents, and representatives (the “Covered Entities”) against all liability, claims, costs,
					damages, settlements, and expenses (including interest, penalties,
					attorney fees and expert witness fees) (“Liabilities”) incurred by any Covered Entity in any
					way arising out of or relating to this Agreement,
					your violation of this Agreement, your User Content, or your use of the Sites and/or our
					Services. Channel Factory reserves the right, at your expense,
					to assume the exclusive defense and control of any matter otherwise subject to
					indemnification by you, and in such case,
					you agree to cooperate with our defense of such claim.
				</li>
				<li>
					THE COVERED ENTITIES MAKE NO WARRANTY OF ANY KIND, WHETHER EXPRESS, IMPLIED, STATUTORY OR
					OTHERWISE, INCLUDING WITHOUT LIMITATION WARRANTIES OF MERCHANTABILITY,
					FITNESS FOR A PARTICULAR USE, AND NON INFRINGEMENT. THE COVERED ENTITIES DO NOT MAKE ANY
					REPRESENTATION AS TO THE POTENTIAL REVENUES OR OTHER BENEFITS
					YOU MAY REALIZE BY USING THE SERVICES. THE SITES AND THE SERVICES ARE PROVIDED AS IS AND AS
					AVAILABLE. WE DO NOT REPRESENT THAT THE SITES OR THE SERVICES
					WILL BE CONTINUOUSLY AVAILABLE, ERROR FREE, OR FREE OF VIRUSES, OR THAT PROBLEMS WILL BE
					CORRECTED. Like all Internet businesses, our Sites and Services
					are vulnerable to down time (1) caused by outages to any public Internet backbones, networks
					or servers, (2) caused by any failures of your equipment,
					systems or local access services, (3) for previously scheduled maintenance or (4) relating
					to events beyond our control such as strikes, riots, insurrection,
					fires, floods, explosions, war, governmental action, labor conditions, earthquakes, natural
					disasters, or interruptions in Internet services to an area where
					our or your servers are located. We cannot guarantee complete accuracy in the information we
					report.
				</li>
				<li>
					THE COVERED ENTITIES ARE NOT RESPONSIBLE FOR ANYTHING ACCESSED VIA ANY LINKS TO THIRD PARTY
					WEBSITES, SERVICES, SOFTWARE OR ANYTHING ELSE.
					YOU BEAR ALL RISKS ASSOCIATED WITH USING THIRD PARTY LINKS, WEBSITES, ETC.
				</li>
				<li>
					TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE COVERED ENTITIES SHALL NOT BE LIABLE FOR DIRECT,
					CONSEQUENTIAL, INCIDENTAL, INDIRECT, SPECIAL,
					PUNITIVE OR OTHER DAMAGES (INCLUDING WITHOUT LIMITATION LOST PROFITS, BUSINESS INTERRUPTION
					OR LOSS OF BUSINESS INFORMATION) ARISING OUT OF OR RELATED TO THE
					AGREEMENT OR THE USE OF OR INABILITY TO USE THE SITES OR ANY SERVICES, EVEN IF THEY HAVE
					BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
					SOME JURISDICTIONS DO NOT ALLOW LIMITS OF LIABILITY FOR SOME DAMAGES SO THIS LIMITATION MAY
					NOT APPLY TO YOU.
				</li>
			</ol>
		</div>
		<div className="mb-10">
			<div className="title">Payment, Refunds, Upgrading and Downgrading Terms</div>
			<ol className="main">
				<li>All paid plans must enter a valid credit card. Free accounts are not required to provide a
					credit card number.
				</li>
				<li>You must be authorized to use the payment method that you enter when you create a billing
					account.
				</li>
				<li>
					You authorize us to charge you for the Services using your credit card and for any paid
					feature of the Services that you choose to sign up for or use
					while this Agreement is in force.
				</li>
				<li>
					The Services are billed in advance on a monthly basis and are non-refundable. There will be
					no refunds or credits for partial months of service,
					upgrade/downgrade refunds, or refunds for months unused with an open account.
				</li>
				<li>
					All fees are exclusive of all taxes, levies, or duties imposed by taxing authorities, and
					you shall be responsible for payment of all such taxes, levies,
					or duties, excluding only United States (federal or state) taxes.
				</li>
				<li>
					For any upgrade in plan level, you will be charged a prorated amount for the partial month
					of use of the new plan on your next billing cycle.
					The next billing cycle will reflect any such upgrades. Your account Services and features
					will upgrade immediately.
				</li>
				<li>
					For any downgrade in plan level, the credit card that you provided will automatically be
					charged the new rate on your next billing cycle.
					Your account Services will also be downgraded on your next billing cycle.
				</li>
				<li>Downgrading your Channel Factory Services will cause the loss of features in your account.
					Channel Factory does not accept any liability for such loss.
				</li>
				<li>
					If you cancel the Services before the end of your current paid up month, your cancellation
					will take effect at the next billing
					cycle and you will not be charged again.
				</li>
				<li>
					Prices of all Services, including but not limited to monthly subscription plan fees to the
					Services, are subject to change upon 30 days notice from us.
					Such notice may be provided at any time via the email you have provided or by posting the
					changes to the Channel Factory Site (www.channelfactory.com).
				</li>
				<li>
					All enterprise level accounts registered to pay via check, wire-transfer, or Automated
					Clearing House (ACH),
					are due within thirty (30) days of billing date unless otherwise agreed-to by the parties in
					writing. If payment is not received by Channel Factory on the due date,
					the user&rsquo;s account will be frozen and inaccessible until all outstanding payments have
					been processed by Channel Factory.
				</li>
				<li>
					If you&rsquo;re participating in any trial period offer, you must downgrade to a free plan
					or cancel the Services before the end of the trial period to avoid
					incurring new charges. If you do not downgrade to a free plan or cancel your Services and we
					have told you by email (or other means)
					that the Services will convert to a paid subscription at the end of the trial period, you
					authorize us to charge your payment method for the Services.
				</li>
				<li>
					If your credit card information has expired, you must update the information when requested.
					If not, you agree that we have the right to close your account
					or downgrade your account to a free plan without any liability for any loss of data or loss
					of Services.
				</li>
				<li>
					Channel Factory uses a third-party intermediary to manage credit card processing and this
					intermediary is not permitted to store, retain or use your billing
					information except to process your credit card information for Channel Factory.
				</li>
			</ol>
		</div>
		<div className="mb-10">
			<div className="title">Termination</div>
			<ol className="main">
				<li>
					We reserve the right to suspend or terminate your access to the Sites and the Services
					and/or your Account at any time for any or no reason.
					This is not our exclusive remedy under any circumstances.
				</li>
				<li>
					No refunds or credits for subscription plan charges or other fees or payments will be
					provided to you if you elect to terminate your Services
					plan or cancel your Account prior to the end of your then effective billing cycle. Following
					the termination or cancellation of your subscription to the
					Services and/or Account, Channel Factory reserves the right to close your Account and delete
					any associated data in the normal course of operation.
				</li>
				<li>If you close your Account voluntarily, we may retain your Account information and use it in
					accord with our Privacy Policy.
				</li>
				<li>This Agreement will survive termination or suspension of your access to the Sites and/or
					Services and/or closure of your Account.
				</li>
			</ol>
		</div>
		<div className="mb-10">
			<div className="title">Miscellaneous</div>
			<ol className="main">
				<li>The Agreement incorporates all Channel Factory policies, which can be found on the Sites.
				</li>
				<li>
					We reserve the right to change the Agreement and our policies at any time. When we make such
					changes, we will post them to our websites and you
					will be able to access them through the same link you used before. Your use of the Sites
					and/or the Services after such changes constitutes acceptance
					of the new terms and/or policies.
				</li>
				<li>Channel Factory will be entitled to recover any legal fees and other costs associated with
					enforcing the Agreement.
				</li>
				<li>
					We will communicate with you either by emailing the address associated with your account or
					by posting to a blog on the Sites or on the Sites themselves.
					You and we will give any notices required or permitted by the Agreement (other than legal
					process) by email with the proviso that we will email your account
					address and you will email us at <a
					href="mailto:contact@viewiq.com">contact@viewiq.com</a>. Emails to other
					addresses will not satisfy any
					notice requirement.
				</li>
				<li>You are responsible for being informed about and complying with all laws, rules and
					regulations that apply to your use of the Sites and all Services.
				</li>
				<li>
					The Agreement is the entire agreement between you and Channel Factory and it replaces any
					other agreement between us on this subject. Aside from our right to make
					changes described in this Agreement, any amendments to the Agreement must be in a writing
					signed by both parties.
				</li>
				<li>You cannot assign the Agreement without our written agreement. We can assign the agreement
					to any entity that agrees to be bound by the terms of the Agreement.
				</li>
				<li>
					The Agreement is governed by California State law. The parties will resolve any disputes in
					the courts of the Los Angeles County of California to
					whose exclusive jurisdiction and venue they irrevocably submit, except for any optional
					arbitration as described next. Excluding claims for equitable relief,
					if the total amount in dispute is less than $10,000, either party may elect to resolve the
					claim through binding arbitration by initiating arbitration through
					an established provider that is agreed by the parties. The arbitration must be conducted
					under the following rules: (a) at the choice of the party seeking relief,
					the arbitration shall be conducted by telephone, online, or solely on written submissions;
					(b) no party or witness will make any personal appearance unless the
					parties agree otherwise; and (c) the winning party may have the arbitrator&rsquo;s award
					entered as a judgment in any court of competent jurisdiction.
				</li>
				<li>
					If any provision of the Agreement is unenforceable, the validity and enforceability of the
					remaining provisions will not be affected.
					No waiver will be effective unless it is in an explicit writing and signed by an authorized
					representative of the waiving party.
				</li>
			</ol>
		</div>
		<div>Last updated on October 13th, 2017.</div>
	</div>;
}

export default TermsAndConditions;
